import React from 'react'

import Moment from 'moment'
import { DATE_FORMAT } from '../../../../../core/utils/i18n-js'
import { AmountText } from '../../../../../core/components/widget/amountInline'

import { configureField } from '../../../../../core/utils/list'

import { Button, Row } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden, download } = props

  if (loading) {
    return []
  }
  return [
    {
      title: 'ID',
      dataIndex: 'display_id',
      ...configureField('p.id', filters, resize, hidden, true, false, false, 200),
      fixed: 'left'
      // render: (id, record) => <Link to={LAYOUT_FINANCE_PURCHASE_ORDER_SHOW(record.id)}>{record.display_id}</Link>,
    },
    {
      title: 'Date',
      dataIndex: 'date',
      ...configureField('p.date', filters, resize, hidden, true, false, false, 200),
      render: (date) => {
        if (date) return <>{Moment(date).format(DATE_FORMAT)}</>
      }
    },
    {
      title: 'Vendor',
      dataIndex: 'vendor',
      ...configureField('v.name', filters, resize, hidden, true, false, false, 200),
      render: (vendor, record) => <>{vendor?.name}</>
    },
    {
      title: 'Amount',
      dataIndex: 'amount_value',
      ...configureField('p.amountValue', filters, resize, hidden, true, false, true, 200),
      render: (amountValue, record) => {
        return <AmountText value={amountValue} type={record.amount_type} />
      }
    },
    {
      title: 'Attachment',
      dataIndex: 'status',
      ...configureField('i.status', filters, resize, hidden, false, false, true, 200),
      render: (text, record) => {
        return (
          <Row>
            {record.attachment && record.attachment.name && (
              <Button
                style={{ margin: 0 }}
                icon={<DownloadOutlined />}
                size='small'
                onClick={() => download({ id: record.id, name: record.attachment.name })}
              >
                Download
              </Button>
            )}
          </Row>
        )
      }
    }
  ]
}
